import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "unlock",
  "use": "unlock-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 28 28\" id=\"unlock\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 11.964V8c0-4.416 3.584-8 8-8s8 3.584 8 8v2h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2h2V8c0-2.208-1.792-4-4-4S4 5.792 4 8v3.964a2 2 0 0 1-4 0Zm20 6.072a2 2 0 0 0-4 0v2a2 2 0 0 0 4 0v-2Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol